import { Component, OnInit } from '@angular/core';
import { SkillSet } from '../../skill-repo-employee-tiles/skill-repo-employee-tiles.component';
import { EmployeeService } from '../../employee-profile/employee-profile.service';
import { ToastrService } from 'ngx-toastr';


import { log } from 'console';
import { forEach } from 'jszip';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';
import { Router } from '@angular/router';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';

export interface profileinfo {
  firstName: string,
  lastName: string,
  grade: string,
  experience: number,
  isDeleted: string,
  location: string,
  swotInfo: string,
  employeeId: number,
  domains: string,
  resume: string,
  competencies: string,
  smeFactory: string
}


@Component({
  selector: 'app-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.css']
})



export class ProfileViewComponent implements OnInit {
  skillSets: SkillSet[] = [
    { color: 1, name: 'Microsoft' },
    { color: 1, name: '.Net' },
    { color: 1, name: 'Web API' },
    { color: 1, name: 'Sharepoint' },
    { color: 2, name: 'SSRS' },
    { color: 2, name: 'Mongo DB' },
    { color: 3, name: 'Tabluse' },

  ];
  data: any;
  employeeId: number;
  surname: any;
  myArray: any[] = [];
  competencyName: any[] = [];
  domains: string[];
  smeFactory: any;
  certifications: string[];
  smeNames: any;
  primarySkills: any;
  skills: any;
  skillList = [];
  exp: number = 0;
  subCompetencyName: string;
  competency: string;
  employeeProfileInfo: any;
  expYears: number;
  expMonths: number;
  LeadershipRole: boolean;
  roles: any;
  competencyLeaderRole: boolean;
  constructor(private employeeService: EmployeeService, private toastr: ToastrService, private shareSkillService: SharedSkillService, private auth: AuthServiceService, private router: Router) { }

  ngOnInit() {
    
    const empId = localStorage.getItem('Id');
    this.employeeId = parseInt(empId);
    this.getProfileDetailsById();
  }

  getProfileDetailsById() {
    this.skillList = [];
    this.employeeService.GetProfileDetailsById(this.employeeId).subscribe(res => {
      if (res.data) {
        this.employeeProfileInfo = res.data;
        this.exp = this.employeeProfileInfo.experience;
        this.expYears = Math.floor(this.exp);
        this.expMonths = Math.round((this.exp - this.expYears) * 12);
        this.competency = this.employeeProfileInfo.competencyName;
        this.subCompetencyName = this.employeeProfileInfo.subCompetencyNames;
        this.skillList = this.employeeProfileInfo.primaryDefaultSkills;
        this.certifications = this.employeeProfileInfo.certifications;
        this.domains = this.employeeProfileInfo.domains; 
        
      }
      else {
        this.toastr.warning("No Data of employee");
      }
    });
  }

  getPrimaryDefaultSkills(primarySkills) {
    return primarySkills && primarySkills.length ? primarySkills.map(pri => pri.skill).join(', ') : null
  }
  naviagateToEmployeeDetails() {
    this.shareSkillService.setEmployeeId(this.employeeId)
    this.shareSkillService.setMode(false)
    this.roles = this.auth.getRole();
    if (this.roles.includes(GsdRoles.CompetencyLeader) || this.roles.includes(GsdRoles.SubCompetencyLeader) || this.roles.includes(GsdRoles.SuperAdmin)) {
      this.competencyLeaderRole = true;
    } if (this.roles.includes(GsdRoles.Leadership)) {
      this.LeadershipRole = true;
    }
    if (this.competencyLeaderRole || this.LeadershipRole) {
      this.router.navigate(["Home/Dashboard/Profile_view/Employee_details"])
    }
    else {
      this.router.navigate(["Dashboard/Profile_view/Employee_details"])
    }
  }

  cardColor: string = '#FFF';
  cardText: string;
  cardTextColor: string;
  getTooltipText(status: number | undefined): string {
    if (status === 1) {
      this.cardColor = '#BEE2FD';
      this.cardTextColor = '#036CA7';
      this.cardText = 'S';
      return 'Submitted';
    } else if (status === 2) {
      this.cardColor = '#E4EAEE';
      this.cardTextColor = '#585858';
      this.cardText = 'N';
      return 'Not Submitted';
    } else if (status === 3) {
      this.cardColor = '#c9ecd9';
      this.cardTextColor = '#007e3a';
      this.cardText = 'A';
      return 'Approved';
    }
    else if (status === 4) {
      this.cardColor = '#FFCCCB';
      this.cardTextColor = '#E92C2C';
      this.cardText = 'R';
      return 'Rejected';
    }
    else {
      this, this.cardText = 'U';
      return 'Unknown Status';
    }
  }
}

